var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent, computed, toRef } from '@vue/composition-api';
import { createContext, resolveComponent, useContext, composeExport, } from '../__builtins__/shared';
import { observer } from '@formily/reactive-vue';
import { h, useField } from '@formily/vue';
import { isArr, isValid, isEmpty } from '@formily/shared';
import { stylePrefix } from '../__builtins__/configs';
import { Space } from '../space';
import { Switch as VanSwitch, Rate as VanRate, Uploader as VanUploader, Tag, Field as VanInput, } from 'vant';
var prefixCls = "".concat(stylePrefix, "-preview-text");
var PlaceholderContext = createContext('N/A');
export var usePlaceholder = function (value) {
    var placeholderCtx = useContext(PlaceholderContext);
    var placeholder = computed(function () {
        return isValid(value === null || value === void 0 ? void 0 : value.value) && value.value !== ''
            ? value.value
            : resolveComponent(placeholderCtx.value) || 'N/A';
    });
    return placeholder;
};
var Input = defineComponent({
    name: 'FPreviewTextInput',
    props: ['value'],
    setup: function (props, _a) {
        var attrs = _a.attrs;
        var value = toRef(props, 'value');
        var placeholder = usePlaceholder(value);
        return function () {
            return h('div', {
                class: [prefixCls, "".concat(stylePrefix, "-preview-input")],
                style: attrs.style,
                attrs: __assign(__assign({}, attrs), { disabled: false }),
            }, {
                default: function () { return [
                    [
                        h('span', {
                            class: ["".concat(stylePrefix, "-preview-input-title")],
                        }, {
                            default: function () { return [attrs.label]; },
                        }),
                    ],
                    placeholder.value,
                ]; },
            });
        };
    },
});
var Checkbox = observer(defineComponent({
    name: 'FPreviewTextCheckbox',
    props: [],
    setup: function (_props, _a) {
        var _b, _c;
        var attrs = _a.attrs;
        var fieldRef = useField();
        var field = fieldRef.value;
        var props = attrs;
        var dataSource = ((_b = field === null || field === void 0 ? void 0 : field.dataSource) === null || _b === void 0 ? void 0 : _b.length)
            ? field.dataSource
            : ((_c = props === null || props === void 0 ? void 0 : props.options) === null || _c === void 0 ? void 0 : _c.length)
                ? props.options
                : [];
        var placeholder = usePlaceholder();
        var getSelected = function () {
            var value = props.value;
            if (props.multiple) {
                return isArr(value)
                    ? value.map(function (val) { return ({ label: val, value: val }); })
                    : [];
            }
            else {
                return !isEmpty(value) ? [{ label: value, value: value }] : [];
            }
        };
        var getLabels = function () {
            var selected = getSelected();
            if (!selected.length) {
                return h(Tag, {}, {
                    default: function () { return placeholder.value; },
                });
            }
            return selected.map(function (_a, key) {
                var _b;
                var value = _a.value, label = _a.label;
                var text = ((_b = dataSource === null || dataSource === void 0 ? void 0 : dataSource.find(function (item) { return item.name == value; })) === null || _b === void 0 ? void 0 : _b.label) || label;
                return h(Tag, {
                    key: key,
                    props: {
                        size: 'medium',
                        type: 'primary',
                    },
                }, {
                    default: function () { return text || placeholder.value; },
                });
            });
        };
        return function () {
            return h(Space, {
                class: [prefixCls],
                style: attrs.style,
            }, {
                default: function () { return getLabels(); },
            });
        };
    },
}));
var Switch = observer(defineComponent({
    name: 'FPreviewTextSwitch',
    setup: function (props, _a) {
        var attrs = _a.attrs, slots = _a.slots;
        return function () {
            return h(VanSwitch, {
                class: [prefixCls],
                style: attrs.style,
                attrs: __assign(__assign({ size: 20 }, attrs), { disabled: true }),
            }, slots);
        };
    },
}));
var Stepper = observer(defineComponent({
    name: 'FPreviewTextStepper',
    setup: function (props, _a) {
        var attrs = _a.attrs;
        var placeholder = usePlaceholder();
        return function () {
            return h('div', {
                class: [prefixCls],
                style: attrs.style,
                attrs: __assign(__assign({}, attrs), { disabled: false }),
            }, {
                default: function () { return [attrs.value || placeholder.value]; },
            });
        };
    },
}));
var Rate = observer(defineComponent({
    name: 'FPreviewTextRate',
    setup: function (props, _a) {
        var attrs = _a.attrs, slots = _a.slots;
        var placeholder = usePlaceholder();
        return function () {
            return attrs.value
                ? h(VanRate, {
                    class: [prefixCls],
                    style: attrs.style,
                    attrs: __assign(__assign({ size: 20, count: Math.ceil(attrs.value && Number(attrs.value)) }, attrs), { disabled: false }),
                }, slots)
                : h('div', {
                    class: [prefixCls],
                    style: attrs.style,
                }, {
                    default: function () { return [placeholder.value]; },
                });
        };
    },
}));
var Slider = observer(defineComponent({
    name: 'FPreviewTextSlider',
    setup: function (props, _a) {
        var attrs = _a.attrs;
        var placeholder = usePlaceholder();
        return function () {
            return h('div', {
                class: [prefixCls],
                style: attrs.style,
                attrs: __assign(__assign({}, attrs), { disabled: false }),
            }, {
                default: function () { return [attrs.value || placeholder.value]; },
            });
        };
    },
}));
var Uploader = observer(defineComponent({
    name: 'FPreviewTextUploader',
    setup: function (props, _a) {
        var attrs = _a.attrs, slots = _a.slots, listeners = _a.listeners;
        var placeholder = usePlaceholder();
        return function () {
            var _a;
            return ((_a = attrs.value) === null || _a === void 0 ? void 0 : _a.length)
                ? h(VanUploader, {
                    class: [prefixCls],
                    style: attrs.style,
                    attrs: __assign(__assign({}, attrs), { deletable: false, showUpload: false, fileList: attrs.value, disabled: false }),
                    on: listeners,
                }, slots)
                : h('div', {
                    class: [prefixCls],
                    style: attrs.style,
                    attrs: attrs,
                }, {
                    default: function () { return [placeholder.value]; },
                });
        };
    },
}));
var Picker = observer(defineComponent({
    name: 'FPreviewTextPicker',
    setup: function (props, _a) {
        var attrs = _a.attrs;
        var _b = attrs.formItemProps, formItemProps = _b === void 0 ? {} : _b;
        var placeholder = usePlaceholder();
        return function () {
            return h(VanInput, {
                class: [prefixCls],
                style: attrs.style,
                attrs: __assign(__assign({}, formItemProps), { disabled: false }),
            }, {
                input: function () { return attrs.value || placeholder.value; },
            });
        };
    },
}));
var DatetimePicker = observer(defineComponent({
    name: 'FPreviewTextDatetimePicker',
    setup: function (props, _a) {
        var attrs = _a.attrs;
        var _b = attrs.formItemProps, formItemProps = _b === void 0 ? {} : _b;
        var placeholder = usePlaceholder();
        return function () {
            return h(VanInput, {
                class: [prefixCls],
                style: attrs.style,
                attrs: __assign(__assign({}, formItemProps), { disabled: false }),
            }, {
                input: function () { return attrs.value || placeholder.value; },
            });
        };
    },
}));
var Calendar = observer(defineComponent({
    name: 'FPreviewTextCalendar',
    setup: function (props, _a) {
        var attrs = _a.attrs;
        var _b = attrs.formItemProps, formItemProps = _b === void 0 ? {} : _b;
        var placeholder = usePlaceholder();
        return function () {
            return h(VanInput, {
                class: [prefixCls],
                style: attrs.style,
                attrs: __assign(__assign({}, formItemProps), { disabled: false }),
            }, {
                input: function () { return attrs.value || placeholder.value; },
            });
        };
    },
}));
var Cascader = observer(defineComponent({
    name: 'FPreviewTextCascader',
    setup: function (props, _a) {
        var attrs = _a.attrs;
        var _b = attrs.formItemProps, formItemProps = _b === void 0 ? {} : _b;
        var placeholder = usePlaceholder();
        return function () {
            return h(VanInput, {
                class: [prefixCls],
                style: attrs.style,
                attrs: __assign(__assign({}, formItemProps), { disabled: false }),
            }, {
                input: function () { return attrs.value || placeholder.value; },
            });
        };
    },
}));
var Area = observer(defineComponent({
    name: 'FPreviewTextArea',
    setup: function (props, _a) {
        var attrs = _a.attrs;
        var _b = attrs.formItemProps, formItemProps = _b === void 0 ? {} : _b;
        var placeholder = usePlaceholder();
        return function () {
            return h(VanInput, {
                class: [prefixCls],
                style: attrs.style,
                attrs: __assign(__assign({}, formItemProps), { disabled: false }),
            }, {
                input: function () { return attrs.value || placeholder.value; },
            });
        };
    },
}));
var Text = defineComponent({
    name: 'FPreviewText',
    setup: function (_props, _a) {
        var attrs = _a.attrs;
        var placeholder = usePlaceholder();
        return function () {
            return h('div', {
                class: [prefixCls],
                style: attrs.style,
            }, {
                default: function () { return placeholder.value; },
            });
        };
    },
});
export var PreviewText = composeExport(Text, {
    Input: Input,
    Checkbox: Checkbox,
    Switch: Switch,
    Stepper: Stepper,
    Rate: Rate,
    Slider: Slider,
    Uploader: Uploader,
    Picker: Picker,
    DatetimePicker: DatetimePicker,
    Area: Area,
    Calendar: Calendar,
    Cascader: Cascader,
    Placeholder: PlaceholderContext.Provider,
    usePlaceholder: usePlaceholder,
});
export default PreviewText;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vant/esm/preview-text/index.js
// module id = null
// module chunks = 